export default {
    title: 'Create innovation project',
    pageTitle: 'CREATE - INNOVATION PROJECT',
    eweInformation: '<b>Important note from your company:</b></br>' +
  'Less is more: Please be brief.</br> ' +
  'Only information classified as "INTERNAL" or public information may be posted and linked (cf. Company Instructions on Information Classification).</br>' +
  ' Every employee is responsible for ensuring that his or her information is only used within the permissible limits. ',

    feedback: {
        success: 'The innovation project "{title}" was successfully saved.'
    }
}
